import React, { useEffect, useMemo, useState } from "react";
import { CreateButton } from "../../../../Components/Utils/Buttons";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import {
  TextMediumSM,
  TextMediumXS,
} from "../../../../Components/Text/MediumText";
import { TextSM, TextXS } from "../../../../Components/Text/NormalText";
import axiosInstance from "../../../../Services/axiosCommon";
import NuAmount from "../../../../Components/Utils/NuAmount";
import { useFormik } from "formik";
import * as yup from "yup";
import { useToast } from "../../../../Components/Others/ToastServices";
import { NuInput } from "../../../../Components/Utils/Input";
import EditIcon from "../../../../Components/Icons/Edit";
import FullScreenIcon from "../../../../Components/Icons/FullScreen";
import QuoteComparisonTable from "./QuoteComparisonTable";
import NuDate from "../../../../Components/Utils/NuDate";
import Info from "../../../../Components/Icons/Info";
import {
  CalPercentage,
  CalPercentageSelling,
} from "../../../../Components/Utils/OtherFuction";
import { formatDisplaySno } from "../../../../Components/Utils/formatDisplaySno";

function ViewQuote({ startLoading = false, backUrl = "" }) {
  const [fullview, setFullview] = useState(false);
  const { quotesEditId } = useParams();
  const location = useLocation();
  const data = location?.state?.data;

  const { prId: viewqoutesId } = useOutletContext();

  const toast = useToast();
  const navigate = useNavigate();

  const [isEditing, setIsEditing] = useState(false);

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  // const { data: currency } = UseDropDown('/supplier-quotations/currency/drop-down');
  const [land, setland] = useState(0.0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMarginModalOpen, setIsMarginModalOpen] = useState(false);
  const [marginValue, setMarginValue] = useState(0);
  const [marginChange, setMarginChange] = useState("");
  const [createNew, setCreateNew] = useState({
    currencyId: null,
    duttyCost: 0,
    saberCost: 0,
    tptCost: 0,
    landedCost: 0,
    otherCost: 0,
    itemCount: 0,
  });

  const [duty, setDuty] = useState(0);
  const [tpt, setTpt] = useState(0);
  const [saber, setSaber] = useState(0);
  const [other, setOther] = useState(0);
  const [total, setTotal] = useState(0);
  const [dutyPerProduct, setDutyPerProduct] = useState(0);
  const [tptPerProduct, setTptPerProduct] = useState(0);
  const [saberPerProduct, setSaberPerProduct] = useState(0);
  const [otherPerProduct, setOtherPerProduct] = useState(0);
  const [totalPerProduct, setTotalPerProduct] = useState(0);
  const [productCount, setProductCount] = useState(0);
  const [vendorValue, setVendorValue] = useState();
  const [finalProId, setFfinalProId] = useState([]);
  const [sellingPrices, setSellingPrices] = useState({});
  const [gPEditShow, setGPEditShow] = useState(false);

  const [dynamicHeaderCount, setDynamicHeaderCount] = useState(3);
  const [datas, setData] = useState([]);

  const [stateValue, setStateValue] = useState([]);

  const [supplierList, setSuppliersList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const [latestCqProducts, setLatestCqProducts] = useState([]);

  const getLatestCqProducts = async (prId) => {
    if (!prId) return;
    try {
      const res = await axiosInstance.get(
        `/customer-quotations/latest-cq-products/${prId}`,
      );

      if (res.data?.status === true || res.status === 200) {
        const data = res.data?.data || res.data;
        console.log("Latest CQ Products:", data);
        setLatestCqProducts(Array.isArray(data) ? data : []);
        return data;
      }
    } catch (error) {
      console.error("Error fetching latest CQ products:", error);
      toast.open({
        type: "error",
        message: "Error",
        description:
          error?.response?.data?.message || "Failed to fetch latest CQ products.",
      });
    }
  };

  const getPreviousCqProducts = async (id) => {
    if (!id) return;
    try {
      const res = await axiosInstance.get(
        `/customer-quotations/previous-cq-products/${id}`,
      );

      if (res.data?.status === true || res.status === 200) {
        const data = res.data?.data || res.data;
        console.log("Previous CQ Products:", data);
        setLatestCqProducts(Array.isArray(data) ? data : []);
        return data;
      }
    } catch (error) {
      console.error("Error fetching previous CQ products:", error);
      toast.open({
        type: "error",
        message: "Error",
        description:
          error?.response?.data?.message ||
          "Failed to fetch previous CQ products.",
      });
    }
  };

  useEffect(() => {
    if (quotesEditId) {
      getPreviousCqProducts(quotesEditId);
    } else if (viewqoutesId) {
      getLatestCqProducts(viewqoutesId);
    }
  }, [quotesEditId, viewqoutesId]);
  const handleMouseEnter = () => {
    const timeout = setTimeout(() => {
      setShowTooltip(true);
    }, 1000);
    setHoverTimeout(timeout);
  };

  const handleMouseLeave = () => {
    if (hoverTimeout) clearTimeout(hoverTimeout);
    setShowTooltip(false);
  };

  const [showTooltipprice, setShowTooltipprice] = useState(false);
  const [hoverTimeoutprice, setHoverTimeoutprice] = useState(null);

  const handleMouseEnterprice = () => {
    const timeout = setTimeout(() => {
      setShowTooltipprice(true);
    }, 1000); // Delay of 1 second
    setHoverTimeoutprice(timeout);
  };

  const handleMouseLeaveprice = () => {
    clearTimeout(hoverTimeoutprice);
    setShowTooltipprice(false);
  };

  const dynamicHeaders = Array.from(
    { length: dynamicHeaderCount },
    (_, index) => (
      <React.Fragment key={`dynamic-header-${index}`}>
        <th className=" w-[500px] border-r border-[#acaaaa]">
          <div className="w-full border border-x-0 border-y-0 bg-[#C4C2C2]-300  py-1">
            <div className="w-full py-1 flex justify-center items-center">
              <div className="px-2 text-xs">
                {(supplierList[index]?.name && supplierList[index]?.name) ||
                  `Supplier ${index + 1}`}
                <p className=" text-[10px] font-light">
                  {supplierList[index]?.type || ""}
                </p>
              </div>
              <div className=" ml-2 h-7">
                <div className=" text-left font-medium text-[9px] leading-3">
                  Ref : {supplierList[index]?.ref || "#"}
                </div>
                <div className=" text-left font-medium text-[9px] leading-3">
                  Prepared By :{" "}
                  <span className=" capitalize">
                    {supplierList[index]?.preparedBy || "-"}
                  </span>{" "}
                </div>
              </div>
              <div className=" ml-2 h-7">
                <div className=" text-left font-medium text-[9px] leading-3">
                  {supplierList[index]?.date ? (
                    <NuDate
                      value={supplierList[index]?.date}
                      format="DD-MMM-YYYY"
                    />
                  ) : (
                    "date"
                  )}
                </div>
                <div className=" text-left font-medium text-[9px] leading-3">
                  Purchaser :{" "}
                  <span className=" capitalize">
                    {supplierList[index]?.purchaser || "-"}
                  </span>{" "}
                </div>
              </div>
            </div>

            <div className="w-full h-0.5 opacity-30 bg-[#C4C2C2] mx-auto"></div>
            <div className="text-xs flex w-full justify-between items-center">
              <th className="w-[200px] py-1 relative border-r border-[#acaaaa]">
                <p className="flex gap-1 text-center items-center justify-center">
                  Unit Price
                  <div className=" popover-menu cursor-pointer relative">
                    <span>
                      <Info color="white" />
                    </span>
                    <div className="hidden absolute z-50 top-4 right-4  popover-menu-item   font-medium border border-teal-700 text-black bg-white text-xs rounded-lg p-2 shadow-lg  min-w-[250px]">
                      <table className=" text-left border-collapse w-full">
                        <TempCom
                          label="LCost"
                          value={supplierList[index]?.lCost || "0"}
                        />
                        <TempCom
                          label="Other"
                          value={supplierList[index]?.others || "0"}
                        />
                        <TempCom
                          label="Total"
                          value={supplierList[index]?.boxTotal || "0"}
                        />
                      </table>
                    </div>
                  </div>
                </p>
              </th>
              <th className="w-[100px] py-1 border-r border-[#acaaaa]">
                <p className="flex gap-1 justify-center items-center">
                  GP
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      setGPEditShow((pev) => !pev);
                    }}
                    title={gPEditShow ? "Disable GP Editing" : "Enable GP Editing"}
                  >
                    <EditIcon
                      width={"15"}
                      height={"15"}
                      color={gPEditShow ? "yellow" : "currentColor"}
                    />
                  </span>
                </p>
              </th>
              <th className="w-[200px] py-1">Selling Price</th>
            </div>
          </div>
        </th>
      </React.Fragment>
    ),
  );

  const handleGPChange = (e, supId, proId) => {
    let List = [...stateValue];
    let value = List.find((i) => i.quoteId === supId && i.productId === proId);
    console.log("=================");
    console.log(value);
    console.log("=================");

    if (value) {
      value.gp = parseFloat(e.target.value).toFixed(2);

      let price = !isNaN(value.LCSP) ? parseFloat(value.LCSP).toFixed(2) : 0;
      let gp = !isNaN(value.gp) ? parseFloat(value.gp).toFixed(2) : 0;
      value.sellingPrice = parseFloat(
        parseFloat(price * 100) / parseFloat(100 - gp),
      ).toFixed(2);

      setStateValue(List);
      updateSellingPricesGP(value.id, gp);
      console.log("selingPrice...", sellingPrices);
    }
  };

  const updateSellingPricesGP = (id, gp) => {
    setSellingPrices((prevPrices) => ({
      ...prevPrices,
      [id]: {
        ...prevPrices[id], // Preserve existing landedCost and other properties
        gp: gp, // Update the gp value
      },
    }));
  };

  const handleLCChange = (e, supId, proId) => {
    let List = [...stateValue];
    let value = List.find((i) => i.vendorId === supId && i.productId === proId);
    if (value) {
      value.landedCost = parseFloat(e.target.value).toFixed(2);

      // Calculate the selling price ((unitPrice+landingCost)*100)/(100-GP)
      let unitPrice = !isNaN(value.convertedPrice)
        ? parseFloat(value.convertedPrice)
        : 0;
      let LC = !isNaN(value.landedCost) ? parseFloat(value.landedCost) : 0;
      let LCSellingPrice = parseFloat(LC + unitPrice).toFixed(2);
      let gp = !isNaN(value.gp) ? parseFloat(value.gp).toFixed(2) : 0;
      value.sellingPrice = (LCSellingPrice * 100) / (100 - gp);

      setStateValue(List);
      updateSellingPricesLC(value.id, LC);
      console.log("selingPrice...", sellingPrices);
    }
  };

  const updateSellingPricesLC = (id, LC) => {
    setSellingPrices((prevPrices) => ({
      ...prevPrices,
      [id]: {
        ...prevPrices[id], // Preserve existing landedCost and other properties
        landedCost: LC, // Update the gp value
      },
    }));
  };

  function handleChange(e, supId, proId) {
    let List = [...stateValue];
    let value = List.find((i) => i.quoteId == supId && i.productId == proId);
    console.log(List, "List", value, "value", supId, "supId", proId, "proId");

    value.isSelected = e.target.checked;
    setStateValue(List);
    FinalProductList(value.id);
  }

  function FinalProductList(id) {
    if (finalProId.some((i) => i == id) == true) {
      let tempValue = finalProId.filter((i) => i != id);
      console.log("tem", tempValue);
      setFfinalProId(tempValue);
    } else {
      setFfinalProId([...finalProId, id]);
    }
  }

  function MarginCompleted() {
    setIsMarginModalOpen(false);
    setMarginValue(0);
    setMarginChange("");
  }

  function getViewQuotes(prId) {
    setIsLoading(true);

    axiosInstance
      .get(`/supplier-quotations/quot-compare/${prId}`)
      .then((res) => {
        console.log(res.data);
        if (res.data.data) {
          setData(formatDisplaySno(res.data?.data?.products));
          // console.log(formatDisplaySno(res.data?.data?.products), "formatDisplaySno", datas)
          setProductCount(res?.data?.data?.products?.length || 0);
          setDynamicHeaderCount(
            res.data?.data?.vendorNames
              ? res.data?.data?.vendorNames.length
              : 0,
          );
          setSuppliersList(res.data?.data?.vendorNames);
          setStateValue(res.data?.data?.vendors);
          let vendorsItem = res.data?.data?.vendors || [];
          let TempValue = [];
          vendorsItem.forEach((i) => {
            if (i.isSelected) {
              TempValue.push(i.id);
            }
          });
          setFfinalProId(TempValue);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  }

  const [currency, setCurrency] = useState([]);
  async function getCurrency() {
    axiosInstance
      .get("/currency/")
      .then((res) => {
        console.log("daataa", res.data.data);
        let data = res.data.data;
        console.log(data, "dddd");
        let tempData = [];
        data.forEach((item) => {
          let tempObject = { value: item.id, label: item.currency };
          tempData.push(tempObject);
        });
        res.data.data && setCurrency(tempData);
      })
      .catch((err) => {
        console.log(err, "err");
      });
  }

  const [vatRate, setVatRate] = useState();
  async function getVatRate() {
    axiosInstance
      .get("/vat/")
      .then((res) => {
        console.log("vat", res.data.data);
        // let data = res.data.data;
        res.data.data && setVatRate(res.data.data.vatRate);
      })
      .catch((err) => {
        console.log(err, "err");
      });
  }

  useEffect(() => {
    getCurrency();
    getVatRate();
    getViewQuotes(viewqoutesId);
  }, [viewqoutesId]);

  useEffect(() => {
    setTotalPerProduct(total / setCreateNew.itemCount);
  }, [total]);

  function AddPrice(x, y, z) {
    let UP = x || 0;
    let M = y || 0;
    let PP = z || 0;
    console.log(UP, M, PP);
    return UP + PP;
  }

  function AddTotalPrice(q, x) {
    let Q = q || 0;
    let UP = x || 0;
    return Q * UP;
  }

  function saveProducts() {
    axiosInstance
      .put(`/supplier-quotations/quot-compare/select-quotes/${viewqoutesId}`, {
        products: finalProId,
      })
      .then((res) => {
        if (res.data?.status === true) {
          getViewQuotes(viewqoutesId);
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Updated Successfully.",
          });
          GetProList();
        } else if (res.data?.status === false && res.data?.error) {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Network error.",
          });
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: res.data?.msg || "Warning.",
          });
        }
      })
      .catch((err) => {
        toast.open({
          type: "error",
          message: "Error",
          description: "Network error.",
        });
      });
    console.log("final", finalProId);
  }

  function saveSellingPrice() {
    axiosInstance
      .put(
        `/supplier-quotations/quot-compare/selling-price/${viewqoutesId}`,
        sellingPrices,
      )
      .then((res) => {
        // if (res.data?.status === true) {
        //   toast.open({
        //     type: "success",
        //     message: "Success",
        //     description: res.data?.msg || "Selling Price updated.",
        //   });
        // } else if (res.data?.status === false) {
        //   toast.open({
        //     type: "error",
        //     message: "Failed",
        //     description: res.data.error || "Selling Price not updated.",
        //   });
        // } else {
        //   toast.open({
        //     type: "warning",
        //     message: "Failed",
        //     description: res.data?.msg || "Selling Price not updated.",
        //   });
        // }
      })
      .catch((err) => {
        console.log(err, "err");
        toast.open({
          type: "error",
          message: "Error",
          description: "Network error.",
        });
      });
  }

  const submitEdit = async () => {
    const isAnySelected = stateValue.some((supplier) => supplier.isSelected);

    if (!isAnySelected) {
      toast.open({
        type: "warning",
        message: "Failed",
        description: "Price not Selected.",
      });
      return;
    }
    let LengthOf = Object.keys(sellingPrices).length;
    if (LengthOf > 0) {
      saveSellingPrice();
    }
    saveProducts();

    // if(quotesEditId){
    //   navigate(`/sales/quotes/edit/${quotesEditId}`,{state:{data:{...data}}})
    // }else{
    //   navigate(`/sales/quotes/create`);
    // }
  };

  async function GetProList() {
    await axiosInstance
      .get(`/supplier-quotations/selected-products/drop-down/${viewqoutesId}`)
      .then((res) => {
        console.log("data ***********", res?.data?.data?.products);
        let products = res?.data?.data?.products;

        axiosInstance
          .put(`/customer-quotations/update-products/${quotesEditId}`, {
            products,
          })
          .then((res) => {
            console.log("ok");
          })
          .catch((err) => {
            toast.open({
              type: "error",
              message: "Error",
              description: err.respose.data.error || "Network error.",
            });
          });
      });
  }

  function ClickProducts(value) {
    if (value.isSelected) {
      return false;
    }

    let Value = stateValue.filter((item) => item.productId == value?.productId);
    let click = Value.some((x) => x.isSelected == true);
    return click;
  }
  console.log("viewqoutesId", viewqoutesId, isLoading);

  return (
    <div className="w-full h-full px-2 lg:px-4 py-2 relative">
      {viewqoutesId != "" && isLoading == false && (
        <button
          type="button"
          className="bg-baseColor-primary absolute right-0 -top-8 text-white px-2 py-1 text-xs rounded-md cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-opacity"
          onClick={() => setFullview(true)}
        >
          <FullScreenIcon width={13} height={13} color="white" />
          <span className="hidden lg:block">Full Screen View</span>
        </button>
      )}

      <div className=" lg:w-[calc(100vw-280px)]  h-full  overflow-x-hidden">
        <div className="overflow-x-auto lg:w-[calc(100vw-280px)] rounded-lg">
          <div className=" w-full min-h-[calc(100vh-350px)] max-h-[calc(100vh-320px)]  overflow-y-scroll">
            {viewqoutesId != "" ? (
              <>
                {isLoading == true || startLoading == true ? (
                  // <div className="w-full h-full">
                  <>
                    <div className="w-full">
                      {[...Array(5)].map((_, index) => (
                        <div
                          key={index}
                          className="animate-pulse flex space-x-4"
                        >
                          <div className="rounded-full bg-slate-200 h-10 w-10"></div>
                          <div className="flex-1 space-y-6 py-1">
                            <div className="h-4 bg-slate-200 rounded"></div>
                            <div className="space-y-3">
                              <div className="grid grid-cols-3 gap-4">
                                <div className="h-4 bg-slate-200 rounded col-span-2"></div>
                                <div className="h-4 bg-slate-200 rounded col-span-1"></div>
                              </div>
                              <div className="h-4 bg-slate-200 rounded"></div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <QuoteComparisonTable
                    supplierList={supplierList}
                    dynamicHeaders={dynamicHeaders}
                    datas={datas}
                    stateValue={stateValue}
                    latestCqProducts={latestCqProducts}
                    isEdit={!!quotesEditId}
                    gPEditShow={gPEditShow}
                    ClickProducts={ClickProducts}
                    handleChange={handleChange}
                    handleGPChange={handleGPChange}
                  />
                )}
              </>
            ) : (
              <div className=" w-full h-[calc(100vh-350px)] flex justify-center items-center">
                <p className=" font-semibold text-sm 2xl:text-base text-baseColor-primary">
                  Please Choose YPR
                </p>
              </div>
            )}
          </div>
        </div>
        <div className=" w-full flex items-center justify-between px-4 h-[60px]">
          <div className=" lg:w-[calc(84vw-240px)]">
            <div className=" flex gap-3 py-2 flex-wrap">
              <TextMediumXS color="text-red-700 py-2" content="Notes : " />
              <span className=" flex gap-1 items-center">
                <TextSM
                  color="text-blue-700"
                  otherStyles="leading-3"
                  content="You can edit GP "
                />
              </span>
              {/* <span className=" flex gap-1 items-center">
                <TextSM color="text-blue-700" otherStyles="leading-3" content="and GP. " />
              </span> */}
            </div>
            <div className=" flex gap-3 flex-wrap">
              <span className=" flex gap-1 items-center">
                <div className=" w-4 h-4 border border-solid border-green-500 rounded-full bg-green-100"></div>
                <TextXS content="Lowest Price  ," />
              </span>

              <span className=" flex gap-1 py-2 items-center">
                <div className=" w-4 h-4 border border-solid border-red-500 rounded-full bg-red-100"></div>
                <TextXS content="Highest Price. " />
              </span>

              <span className=" flex gap-1 py-2 items-center">
                <div className=" w-4 h-4 border border-solid border-blue-500 rounded-full bg-blue-100 flex items-center justify-center">
                  <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                </div>
                <TextXS
                  content={
                    quotesEditId
                      ? "Selected in Previous CQ"
                      : "Selected in Latest CQ"
                  }
                />
              </span>
            </div>
          </div>
          <div className=" lg:w-44 flex gap-3 justify-end">
            <CreateButton label="Save" handleClick={submitEdit} svg={false} />
            {/* <CreateButton label="Create Quotes" svg={false} /> */}
          </div>
        </div>
      </div>
      <ModalContainer
        visiable={fullview}
        title=""
        hasButton={false}
        content={
          <>
            <div className=" w-[94vw] relative h-[90vh]">
              <div className="w-full -mt-3 mb-2 flex justify-between items-center">
                <p className=" font-semibold text-sm">Full View</p>
                <button
                  className="absolute top-0 right-0 text-white bg-red-600"
                  onClick={() => setFullview(false)}
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div className="w-full overflow-x-auto max-w-full bg-white rounded-lg">
                <div className=" w-full min-h-[calc(100vh-250px)] max-h-[calc(100vh-150px)] overflow-y-scroll">
                  {isLoading == true || startLoading == true ? (
                    // <div className="w-full h-full">
                    <>
                      <div className="w-full">
                        {[...Array(5)].map((_, index) => (
                          <div
                            key={index}
                            className="animate-pulse flex space-x-4"
                          >
                            <div className="rounded-full bg-slate-200 h-10 w-10"></div>
                            <div className="flex-1 space-y-6 py-1">
                              <div className="h-4 bg-slate-200 rounded"></div>
                              <div className="space-y-3">
                                <div className="grid grid-cols-3 gap-4">
                                  <div className="h-4 bg-slate-200 rounded col-span-2"></div>
                                  <div className="h-4 bg-slate-200 rounded col-span-1"></div>
                                </div>
                                <div className="h-4 bg-slate-200 rounded"></div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <QuoteComparisonTable
                      supplierList={supplierList}
                      dynamicHeaders={dynamicHeaders}
                      datas={datas}
                      stateValue={stateValue}
                      latestCqProducts={latestCqProducts}
                      isEdit={!!quotesEditId}
                      gPEditShow={gPEditShow}
                      ClickProducts={ClickProducts}
                      handleChange={handleChange}
                      handleGPChange={handleGPChange}
                    />
                  )}
                </div>
              </div>
              <div className=" w-full flex items-center justify-between px-4 h-[60px]">
                <div className=" lg:w-[calc(84vw-240px)]">
                  <div className=" flex gap-3 py-2 flex-wrap">
                    <TextMediumXS
                      color="text-red-700 py-2"
                      content="Notes : "
                    />
                    <span className=" flex gap-1 items-center">
                      <TextSM
                        color="text-blue-700"
                        otherStyles="leading-3"
                        content="You can edit GP "
                      />
                    </span>
                    {/* <span className=" flex gap-1 items-center">
                <TextSM color="text-blue-700" otherStyles="leading-3" content="and GP. " />
              </span> */}
                  </div>
                  <div className=" flex gap-3 flex-wrap">
                    <span className=" flex gap-1 items-center">
                      <div className=" w-4 h-4 border border-solid border-green-500 rounded-full bg-green-100"></div>
                      <TextXS content="Lowest Price  ," />
                    </span>

                    <span className=" flex gap-1 py-2 items-center">
                      <div className=" w-4 h-4 border border-solid border-red-500 rounded-full bg-red-100"></div>
                      <TextXS content="Highest Price. " />
                    </span>

                    <span className=" flex gap-1 py-2 items-center">
                      <div className=" w-4 h-4 border border-solid border-blue-500 rounded-full bg-blue-100 flex items-center justify-center">
                        <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                      </div>
                      <TextXS
                        content={
                          quotesEditId
                            ? "Selected in Previous CQ"
                            : "Selected in Latest CQ"
                        }
                      />
                    </span>
                  </div>
                </div>
                <div className=" lg:w-44 w-full flex gap-3 justify-end">
                  <CreateButton
                    label="Save"
                    handleClick={submitEdit}
                    svg={false}
                  />
                  {/* <CreateButton label="Create Quotes" svg={false} /> */}
                </div>
              </div>
            </div>
          </>
        }
        handleClick={() => {
          setFullview(false);
        }}
        closeModal={() => setFullview(false)}
      />
    </div>
  );
}

export default ViewQuote;

function TempCom({ label = "", value = 0, calculation = 0 }) {
  return (
    <tr className=" w-full">
      <td className=" w-[140px] py-1">{label}</td>
      <td className=" w-[10px] py-1">:</td>
      <td className="min-w-[130px] py-1">
        {value}
        {label === "Duty" && calculation !== null && (
          <span>
            {" ("}
            <NuAmount value={calculation} />
            {")"}
          </span>
        )}
      </td>
    </tr>
  );
}


